import Image from "next/image";
import Link from "next/link";
import React from "react";

export interface LocationProps {
  title: string;
  label: string;
  locationIcon: string;
  locationAddress: string;
  locationLink: string;
}

export default function Location({
  title,
  label,
  locationIcon,
  locationAddress,
  locationLink,
}: LocationProps) {
  return (
    <div className="flex flex-col items-start justify-start">
      <h2 className="text-left mb-6 text-2xl">{title}</h2>
      <div className="">
        <p className="mb-4 text-main-black text-base">{label}</p>
        <div className="flex items-start">
          <Image
            src={locationIcon}
            width={20}
            height={20}
            alt={"icon"}
            className="mt-[1px] mr-2"
          />
          <Link href={`${locationLink}`} legacyBehavior>
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="text-main-blue text-base underline underline-offset-2 whitespace-pre-line max-w-[268px]"
            >
              {locationAddress}
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}
